import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetPriTxtAvailableMonths} from '@/features/accesses/activity-report/http/priTxtExport.http'
import {AvailablePriTxtMonths} from '@/features/accesses/activity-report/types'

// Periods for which a DSP Flux export can be generated — drives the month select in the export card.
export const useGetPriTxtAvailableMonths = (
    options?: Omit<UseQueryOptions<AvailablePriTxtMonths>, 'queryKey' | 'queryFn'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.PRI_TXT_AVAILABLE_MONTHS],
        queryFn: httpGetPriTxtAvailableMonths,
        ...options
    })
